import { auth } from "../../../backend/firebaseConfig";

const API_URL = (process.env.REACT_APP_SNOWFLAKE_API_URL || "http://localhost:10001").replace(/\/$/, "");

const fetchIncomePeriods = (token) => fetch(`${API_URL}/api/income-periods`, {
  headers: { Authorization: `Bearer ${token}` },
});

export const getIncomePeriods = async () => {
  const user = auth.currentUser;
  const token = await user?.getIdToken(false);
  if (!token) throw new Error("Please sign in again.");
  let response = await fetchIncomePeriods(token);
  if (response.status === 401) {
    const refreshedToken = await user.getIdToken(true);
    response = await fetchIncomePeriods(refreshedToken);
  }
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || "Unable to load income periods.");
  return body.periods || [];
};
